import { Component, OnInit } from "@angular/core";
import { SelectItem } from "primeng/api";
import { ScreenName, UserActionDescription } from "src/app/enum/user/userActionDescription";
import { UserAction } from "src/app/enum/user/userActions";
import {
  AccessUserInfo,
  LabActionItemTabDetail,
  UserDetail,
  UserLocationFacility,
} from "src/app/models";
import {
  FacilityService,
  LabActionItemService,
  UserService,
} from "src/app/services";
import { LoaderService } from "src/app/services/loader.service";

@Component({
  selector: "bart-lab-action-item",
  templateUrl: "./lab-action-item.component.html",
  styleUrls: ["./lab-action-item.component.scss"],
})
export class LabActionItemComponent implements OnInit {
  facilityList: SelectItem[] = [];
  labActionItemTabs:LabActionItemTabDetail[]=[];
  public userInfo: UserDetail;
  userLocationFacilities: UserLocationFacility[] = [];
  selectedFacilityMasterId?: number = null;
  activeTabIndex:number=0;
  activeTabShortName:string="NLR";
  
  constructor(
    private _facilityService: FacilityService,
    private _loaderService: LoaderService,
    private _labActionItemService: LabActionItemService,
    private _userService: UserService
  ) {}

  ngOnInit() {
    this.userInfo = AccessUserInfo.getUserInfo();
    this.selectedFacilityMasterId =
      AccessUserInfo.getSelectedFacilityMasterId();
    this.GetUserLocations();
  }
  private GetUserLocations() {
    this._loaderService.show();
    this.facilityList = [];
    let getLocationParam = {
      GETUSERLOCATIONS: {
        LOCATION_ID_LIST: null,
        USERNAME: this.userInfo.userName,
      },
      GETUSERLOCATIONS2: {
        USERNAME: this.userInfo.userName,
      },
    };
    if (getLocationParam != null) {
      this._facilityService
        .getUserLocations(JSON.stringify(getLocationParam))
        .subscribe(
          (resp: any) => {
            if (resp.facilities) {
              this.userLocationFacilities = resp.facilities;
              this.facilityList = this.userLocationFacilities
                .filter(
                  (x) => x.LocationModality && x.LocationModality.length > 0
                )
                .map((data) => ({
                  label: data.FacilityDisplayName,
                  value: data.FacilityMasterID,
                }));
              if (
                this.facilityList &&
                this.facilityList.length &&
                this.selectedFacilityMasterId == null
              ) {
                this.selectedFacilityMasterId = this.facilityList[0].value;
              }
              this._loaderService.hide();
              this.facilityChanged();
            } else {
              this._loaderService.hide();
            }
          },
          (error) => {
            this._loaderService.hide();
            this.facilityList = [];
          }
        );
    }
  }
  public handleTabChanged(event) {
     this.activeTabShortName=this.labActionItemTabs.find(x=>x.TabIndex==event.index).TabShortName;
  }
  facilityChanged() {
    AccessUserInfo.setSelectedFacilityMasterId(
      this.selectedFacilityMasterId.toString()
    );
    this.getLabActionItemTabDetails(true);
     //#region User Action Audit
     this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.FILTER,
      screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
      screenPath: location.pathname,
      key: "FacilityMasterID",
      value: this.selectedFacilityMasterId,
      eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_FACILITY_CHANGED
    });
    //#endregion
  }

  getLabActionItemTabDetails(isFacilityChanged:boolean=false) {
    let getLabActionItemTabDetailsParam = {
      GETLABACTIONITEMTABDETAILS: {
        FacilityMasterID: this.selectedFacilityMasterId,
      },
    };
    this._loaderService.show();
    this._labActionItemService
      .getLabActionItemTabDetails(JSON.stringify(getLabActionItemTabDetailsParam))
      .subscribe(
        (resp: any) => {
          this.labActionItemTabs=resp.getLabActionItemTabDetails;
          if(this.userInfo.bartRoleCode.toLowerCase()!="admin")
          {
            this.labActionItemTabs=this.labActionItemTabs.filter(x=>x.TabShortName!="UNMAPPED");
          }
          let objGreaterThanZeroRecordTab=this.labActionItemTabs.filter(x=>x.RecordCount>0)
          objGreaterThanZeroRecordTab.length && (this.activeTabIndex==0 || isFacilityChanged)?this.activeTabIndex=objGreaterThanZeroRecordTab[0].TabIndex:this.activeTabIndex;
          this.activeTabShortName=this.labActionItemTabs.find(x=>x.TabIndex==this.activeTabIndex).TabShortName;
          this._loaderService.hide();
        },
        (error) => {
          this._loaderService.hide();
        }
      );
  }

  refreshTabCount()
  {
    this.getLabActionItemTabDetails();
  }
}
